'use strict';


// This propery values should be a replica of the ECL.IMS.Rest project property Resources string value
export class AntiForgeryTokenProperies {
    public static Token: string = 'w12LdKDxFDhfiDeqm7DCNtaHE0hpiAxiVjANk2riEMH1zvbAbIBZvKaCRrehiy4b';
    public static Separator: string = '@@##@@';
}